import React, { FC, memo } from 'react'
import { ISpecialitiesListProps } from '../types'
import { SpecialitiesListItem } from './SpecialitiesListItem'
import SC from '../base/SpecialitiesList.styles'

const { Block } = SC

/** Список специальностей */
const SpecialitiesList: FC<ISpecialitiesListProps> = (props) => {
  const {
    items,
    addSearchQueryToInstitutionHref,
    showSelect,
    selectedItems,
    onSelect,
    offSelect,
    exams,
    linkTarget,
  } = props

  return (
    <Block>
      {items.map((speciality) => {
        return (
          <div key={speciality.id}>
            <SpecialitiesListItem
              {...speciality}
              addSearchQueryToInstitutionHref={addSearchQueryToInstitutionHref}
              showSelect={showSelect}
              selectedItems={selectedItems}
              onSelect={onSelect}
              offSelect={offSelect}
              exams={exams}
              linkTarget={linkTarget}
            />

            {speciality.element}
          </div>
        )
      })}
    </Block>
  )
}

export { SpecialitiesList }
export default memo(SpecialitiesList)
